import HTTP from "./http";

export default {
  send(data) {
    return data.data.attributes.cpf
      ? HTTP.post("/physicals", data)
      : HTTP.post("/legals", data);
  }
};



// WEBPACK FOOTER //
// ./src/api/signin.js